import useHttpQuery from 'data/firestore/useHttpQuery';
import { ACTIONS_BASE_URL } from '../../../constants';
import { NexhealthPatientEnvelope } from '../types';

const useNexhealthPatient = (
    agentId: string,
    customerId: string,
    enabled = false,
) => useHttpQuery<NexhealthPatientEnvelope>({
    pathname: `/organizations/${agentId}/apps/nexhealth/customers/${customerId}/patient`,
    server: ACTIONS_BASE_URL,
    key: ['nexhealth', 'patient', agentId, customerId],
    queryOptions: {
        enabled: Boolean(agentId && customerId) && enabled,
        retry: false,
    },
});

export default useNexhealthPatient;
